export default (that) => [
  {
    text: that.$l('menu_text_setting_inv_action') || '设置库存处理方式',
    icon: 'el-icon-s-tools',
    menuType: 'settingInvAction',
    allow: 'I',
    data: {},
  },
  {
    text: that.$l('menu_text_setting_editShortage') || '短装数量修改',
    icon: 'el-icon-edit-outline',
    menuType: 'editShortage',
    allow: 'S',
    disabled: ({ amzPurchaseStatus }) => !['Y'].includes(amzPurchaseStatus),
  },
  {
    text: that.$l('menu_text_setting_viewShortage') || '短装数量修改查询',
    icon: 'el-icon-view',
    menuType: 'viewShortage',
    allow: 'V',
    disabled: ({ amzPurchaseStatus }) => !['Y'].includes(amzPurchaseStatus),
  },
]
